import { PostPlayerSignUpRequest } from '@/api/type/types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface PlayerPhoneNumberFiledProps {
  phoneCode: string;
  formData: PostPlayerSignUpRequest;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const PlayerPhoneNumberFiled = ({
  phoneCode,
  formData,
  onChange,
}: PlayerPhoneNumberFiledProps) => {
  const { t } = useTranslation();
  return (
    <>
      <FormGroup>
        <Label $required>{t('common.mobileNumber')}</Label>
        <Row>
          <CountryCodeInput type="text" value={phoneCode} readOnly />

          <Input
            type="tel"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={onChange}
            placeholder={t('signUp.numberOnly')}
            required
          />
        </Row>
      </FormGroup>

      <FormGroup>
        <Label $required>{t('playerSignUp.clinicNumber')}</Label>
        <Row>
          <CountryCodeInput type="text" value={phoneCode} readOnly />

          <Input
            type="text"
            name="clinicContactNumber"
            value={formData.clinicContactNumber}
            onChange={onChange}
            placeholder={t('signUp.numberOnly')}
            required
          />
        </Row>
      </FormGroup>
    </>
  );
};

export default PlayerPhoneNumberFiled;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface LabelProps {
  $required?: boolean;
}

const Label = styled.label<LabelProps>`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;

  &::after {
    content: ${(props) => (props.$required ? "' *'" : "''")};
    color: #ef4444;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const Input = styled.input`
  height: 40px;
  flex: 1;

  padding: 0 12px;

  font-size: 14px;
  color: #374151;

  border: 1px solid #d1d5db;
  border-radius: 6px;

  outline: none;

  &:focus {
    border-color: #2563eb;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

const CountryCodeInput = styled(Input)`
  width: 72px;
  flex: none;

  text-align: center;
  background: #f9fafb;
  color: #6b7280;
`;
